export default {
  TOP_RIGHT: 'tr',
  TOP_LEFT: 'tl',
  BOTTOM_RIGHT: 'br',
  BOTTOM_LEFT: 'bl',
  CONTEXT: 'context',
  BELOW: 'below',
};



// WEBPACK FOOTER //
// ./src/js/Menus/Positions.js